import { X } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../stores/auth";

export function PinSetupBanner() {
  const userSecurity = useAuth((s) => s.userSecurity);
  const sessionLocked = useAuth((s) => s.sessionLocked);
  const [dismissed, setDismissed] = useState(false);

  if (
    dismissed ||
    sessionLocked ||
    !userSecurity?.pinEnabled ||
    !userSecurity.pinSetupNotify ||
    userSecurity.pinSet
  ) {
    return null;
  }

  return (
    <div className="mb-4 flex items-start gap-3 rounded-xl border border-brand-pink/30 bg-brand-pink/10 px-4 py-3">
      <div className="min-w-0 flex-1">
        <p className="text-xs font-semibold text-white">Set up a PIN for quick re-login</p>
        <p className="mt-0.5 text-xs text-white/60">
          After session timeout you can unlock with a 6-digit PIN instead of your password.{" "}
          <Link to="/profile/security" className="font-semibold text-brand-pink hover:underline">
            Set up PIN
          </Link>
        </p>
      </div>
      <button
        type="button"
        onClick={() => setDismissed(true)}
        className="shrink-0 rounded-lg p-1 text-white/50 hover:bg-white/5 hover:text-white"
        aria-label="Dismiss"
      >
        <X size={14} />
      </button>
    </div>
  );
}
